import React, { useEffect, useState } from "react";

import { Modal, Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import CreateCredentialService from "../services/CreateCredentialService";

const CredentialsCodePage: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setModalVisible(true);
  }, []);

  const handleSubmit = async (values: { code: string }) => {
    try {
      setLoading(true);

      const credentialKind = "Fido2";
      const { code } = values;

      const { initiateResponse, error: initError } = await CreateCredentialService.initiateCreateCredentialWithCode(credentialKind, code);

      if (initError) {
        console.error(initError);
        toast.error("We couldn't start device setup. Please try again.");
        setLoading(false);
        return;
      }

      const credentialName = `Device-${Date.now()}`;
      const challengeIdentifier = initiateResponse.challengeIdentifier;

      const { error: completeError } = await CreateCredentialService.completeCreateCredentialWithCode(
        credentialKind,
        initiateResponse,
        credentialName,
        challengeIdentifier
      );

      if (completeError) {
        console.error(completeError);
        toast.error("We couldn't finish device setup. Please try again.");
      } else {
        toast.success("Device added successfully!");
        setModalVisible(false);
        form.resetFields();
        navigate("/login");
      }
    } catch (error: any) {
      console.error(error);
      toast.error("We couldn't complete this action. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Create New Credential</h1>
        <p className="text-gray-600 text-center mb-6">Enter the credential code to create a new passkey for this device.</p>

        <Modal title="Enter Credential Code" open={modalVisible} onCancel={handleCancel} footer={null} maskClosable={false} width={500}>
          <Form form={form} layout="vertical" onFinish={handleSubmit} className="space-y-4">
            <Form.Item
              name="code"
              label="Credential Code"
              rules={[
                { required: true, message: "Please enter the credential code!" },
                { min: 9, message: "Code must be at least 9 characters long!" },
              ]}
            >
              <Input
                placeholder="Enter 9-digit code (e.g., RYVB2VZTG)"
                maxLength={11}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^A-Z0-9]/g, "").toUpperCase();
                  form.setFieldsValue({ code: value });
                }}
                style={{ fontSize: "16px", padding: "12px" }}
              />
            </Form.Item>

            <div className="flex gap-3">
              <Button type="primary" htmlType="submit" loading={loading} className="flex-1">
                Create Credential
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default CredentialsCodePage;
